<template>
    <div class="no-patients-wrapper">
        <adcetris-logo />

        <div class="no-patients-content">
            <preloader :dotColor="'white'" />
            <div class="header text">Формується черга на консиліум</div>
            <div class="under text">Коли Ви складете та відправите портрет пацієнта, він з’явиться тут</div>
        </div>

        <patient-footer />
    </div>
</template>

<script>
import Preloader from '../Preloader';
import AdcetrisLogo from './AdcetrisLogo';
import PatientFooter from './PatientFooter';

export default {
    components : {
        'preloader' : Preloader,
        'adcetris-logo' : AdcetrisLogo,
        'patient-footer' : PatientFooter
    }    
}
</script>

<style lang="scss">
.no-patients-wrapper{
    width: 100%;
    height: 100%;
    background: url("../../assets/images/moderator/login/login-bg.png") no-repeat center;

    display: flex;
    justify-content: center;
    align-items: center;
}

.no-patients-content{
    .text{
        font-family: 'Helvetica Neue LT Std';
        font-style: normal;
        font-weight: bold;
        font-size: 48px;
        line-height: 60px;
        color: #FFFFFF;
    }

    .header{
        padding-top: 88px;
        padding-bottom: 20px;
    }

    .under{
        font-size: 28px;
        line-height: 35px;
        font-weight: 200;
    }
}
</style>